import { BaseState } from '@/store/base-state';
import { Repairs } from '../../../types';

export default class ReturnZipsState extends BaseState {
  return_zips_loading = false;
  return_zips_list: Repairs.ReturnZip[] = [];
  filters: Repairs.ReturnZipsFilters = {
    search: '',
    date: null,
    status: null,
  };

  transport_companies: Repairs.TransportCompany[] =[]
}
